import { isBefore, parseISO, startOfDay } from 'date-fns';

import { DateRangeFilter } from '@/contexts/table-context';

/**
 * Hires to date applies to a custom range that ended before today. A preset ends
 * today and Lifetime has no end, so their hires already count through today.
 * @param dateRange - The applied filter. eg { startDate: '2026-08-01', endDate: '2026-08-31' }
 * @param today - The browser's today, the same day presets count from.
 * @returns Whether the Hires to date switch can turn on.
 */
export function isHiresToDateEligible(
  dateRange: DateRangeFilter,
  today: Date,
): boolean {
  if (dateRange.preset || !dateRange.startDate || !dateRange.endDate) {
    return false;
  }

  return isBefore(startOfDay(parseISO(dateRange.endDate)), startOfDay(today));
}
